import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";

import { getLedgers_Ajax } from "../../helpers/requests";
import {
  hideLoadingSpinner,
  showLoadingSpinner
} from "../../redux/actions/loadingSpinner";
import {
  formatDateTime,
  handleApiErrors,
  isEmptyArray,
  isValidDate,
  onImageError,
  printContent,
  showAlertDialouge
} from "../../helpers/utils";
import { DateTimeFormats } from "../../constants";

import "./../../assets/css/print-style.css";
import $ from "jquery";

const VisitHistoryPrint = () => {
  const { patientId, completionDateAndTime } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [ledgers, setLedgers] = useState([]);
  const [totalBalance, setTotalBalance] = useState(0);
  const [datesForLedger, setDatesForLedger] = useState([]);
  const [patientName, setPatientName] = useState(null);
  const [isGetLedgerApiCompleted, setIsGetLedgerApiCompleted] = useState(false);

  useEffect(() => {
    if (patientId && !isEmptyArray(datesForLedger)) {
      getLedgerData(patientId);
    }
  }, [patientId, datesForLedger]);

  useEffect(() => {
    if (completionDateAndTime && isValidDate(completionDateAndTime)) {
      getDatesForLedger(completionDateAndTime);
    }
  }, [completionDateAndTime]);

  function getPatientName(ledgers) {
    if (!isEmptyArray(ledgers)) {
      var ledger = ledgers.find((ledger) => ledger.patientFullName != null);
      if (ledger && ledger.patientFullName) {
        setPatientName(ledger.patientFullName);
      }
    }
  }

  function getDatesForLedger(completionDateAndTime) {
    var arr = [];
    var momentObj = moment(completionDateAndTime);

    arr.push(momentObj.format("YYYY-MM-DD"));
    arr.push(momentObj.add(1, "days").format("YYYY-MM-DD"));

    setDatesForLedger(arr);
  }

  function getLedgerData(patientId) {
    if (!isEmptyArray(datesForLedger)) {
      dispatch(showLoadingSpinner());
      getLedgers_Ajax(
        patientId,
        datesForLedger,
        function (response) {
          dispatch(hideLoadingSpinner());

          if (
            response &&
            response.success &&
            response.data &&
            response.data.ledgers &&
            Array.isArray(response.data.ledgers) &&
            response.data.ledgers.length > 0
          ) {
            setLedgers(response.data.ledgers);
            setTotalBalance(response.data.totalBalance);
            getPatientName(response.data.ledgers);
          } else if (response && !response.success) {
            setLedgers([]);
            setTotalBalance(0);
            setPatientName(null);
            showAlertDialouge("Message", response.message, function () {
              navigate("/visit-history");
            });
          }

          setIsGetLedgerApiCompleted(true);
        },
        function (err) {
          dispatch(hideLoadingSpinner());
          handleApiErrors(err);
          setIsGetLedgerApiCompleted(true);
        }
      );
    } else {
      setIsGetLedgerApiCompleted(true);
    }
  }

  function getProviderName() {
    if (!isEmptyArray(ledgers)) {
      var ledger = ledgers.find((ledger) => {
        return ledger && ledger.providerFullName;
      });

      if (ledger && ledger.providerFullName) {
        return ledger.providerFullName;
      }
    }
  }

  function getDateOfService() {
    if (completionDateAndTime && isValidDate(completionDateAndTime)) {
      return formatDateTime(completionDateAndTime, DateTimeFormats.DD_MMM_YYYY);
    }
  }

  function getAmount(amount) {
    if (amount) {
      var ledgerAmount = "$" + Math.abs(amount);

      if (amount < 0) ledgerAmount = "-" + ledgerAmount;

      return ledgerAmount;
    }
    return "$0.00";
  }

  function printVisitHistory() {
    var printDivId = "visit-history-body";
    var header = "";
    var content = "<div>" + $("#" + printDivId).html() + "</div>";
    var title = "Visit history";

    printContent(content, header, title);
  }

  return (
    <body
      style={{ margin: 0, padding: "0px 15px", background: "#f2f2f2" }}
      cz-shortcut-listen="true"
    >
      <div style={{ textAlign: "right", maxWidth: 700, margin: "20px auto" }}>
        <button
          disabled={isEmptyArray(ledgers)}
          onClick={() => printVisitHistory()}
          style={{
            backgroundColor: "#3fbbeb",
            border: "1px solid #3fbbeb",
            borderRadius: "50rem",
            fontSize: 12,
            padding: "3px 15px",
            color: "#fff",
            cursor: "pointer"
          }}
          className="noprint btn"
        >
          <i className="fa fa-print"></i> Print
        </button>
      </div>
      <div
        id="visit-history-body"
        style={{
          maxWidth: 700,
          color: "#5D6267",
          margin: "20px auto",
          padding: "20px 30px",
          fontFamily: "Arial, Helvetica, sans-serif",
          background: "#fff",
          minHeight: 600
        }}
      >
        <table style={{ borderBottom: "3px solid #3fbbeb", width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "100%" }}>
                <table
                  style={{ marginTop: 20, borderSpacing: 0, width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>
                        <a
                          href="javascript:;"
                          style={{
                            display: "inline-block",
                            verticalAlign: "top"
                          }}
                        >
                          <img
                            style={{ width: "250px", height: "auto" }}
                            src="http://member.dental.com/static/media/dental-com-logo.bab1de36375ca371a81d5e02f272ec7e.svg"
                            alt="Logo"
                            width="250"
                            height="50"
                            onError={onImageError}
                          />
                        </a>
                      </th>
                    </tr>
                  </thead>
                </table>
                <table style={{ marginBottom: "60px", marginLeft: "auto" }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontSize: 16,
                          padding: "7px 0",
                          fontWeight: 600
                        }}
                      >
                        Provider Name: {getProviderName()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        {patientName ? (
          <table
            className="patient-detail"
            width="100%"
            style={{ marginTop: 20, borderSpacing: 0 }}
          >
            <thead>
              <tr>
                <th
                  colspan="3"
                  style={{ textAlign: "left", fontSize: 12, padding: "10px 0" }}
                >
                  Patient Name:{" "}
                  <span style={{ color: "#3fbbeb", paddingLeft: 10 }}>
                    {patientName}
                  </span>
                </th>
                <th
                  colspan="2"
                  style={{ textAlign: "left", fontSize: 12, padding: "10px 0" }}
                >
                  Date of Service:{" "}
                  <span style={{ color: "#3fbbeb", paddingLeft: 10 }}>
                    {getDateOfService()}
                  </span>
                </th>
              </tr>
            </thead>
          </table>
        ) : (
          <></>
        )}

        <div className="table-responsive">
          {!isGetLedgerApiCompleted ? (
            <></>
          ) : !isEmptyArray(ledgers) ? (
            <table
              cellspacing="0"
              cellpadding="3"
              border="0"
              width="100%"
              style={{ fontSize: 12, marginTop: 30 }}
              className="table table-hover"
            >
              <thead>
                <tr>
                  <th scope="col">Date of Service</th>
                  <th scope="col">Location</th>
                  <th scope="col">Provider</th>
                  <th scope="col">Code</th>
                  <th scope="col">Description</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                {ledgers.map((ledger, index) => {
                  return (
                    <tr key={index}>
                      <td data-label="Date of Service">
                        {formatDateTime(
                          ledger.date,
                          DateTimeFormats.DD_MMM_YYYY
                        )}
                      </td>
                      <td data-label="Location">{ledger.location}</td>
                      <td data-label="Provider">{ledger.providerFullName}</td>
                      <td data-label="Code">{ledger.code}</td>
                      <td data-label="Description" className="quantity">
                        {ledger.description}
                      </td>
                      <td data-label="Amount">{getAmount(ledger.amount)}</td>
                    </tr>
                  );
                })}
                <tr key={ledgers.length}>
                  <td
                    className="quantity"
                    colspan="6"
                    style={{
                      textAlign: "right",
                      fontWeight: "bold",
                      color: "#212529",
                      paddingRight: 30
                    }}
                  >
                    Total: {getAmount(totalBalance)}
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <div className="d-flex justify-content-center mt-5 mb-5">
              <h2>No ledger data found</h2>
            </div>
          )}
        </div>
      </div>
      <div style={{ textAlign: "center", maxWidth: 700, margin: "20px auto" }}>
        <h1
          style={{
            fontSize: 22,
            fontWeight: "bold",
            color: "#983794",
            fontFamily: "Arial, Helvetica, sans-serif"
          }}
        >
          Thank you for visiting us at dental.com!
        </h1>
      </div>
    </body>
  );
};

export default VisitHistoryPrint;
